export const globalMixin = {
  methods: {
    disabledFutureDates(date) {
      return date > new Date();
    },
    disabledPastDates(from, date) {
      return date < new Date(from) - 24 * 60 * 60 * 1000 || date > new Date();
    },
  },
};
